// src/views/Home.jsx

import Graficas from "../components/Graficas";
import MenuFrontal from "../components/MenuFrontal";
import '../css/HomeIntro.css'

const Home = () => {
  return (
    <div className="container-fluid py-3">

      {/* INDICADORES */}
      <div className="container py-4">

        <div className="text-center mb-4 home-welcome">
          <h1 className="fw-bold">¡Bienvenidos a Mr Gestor!</h1>

          <p className="lead text-secondary">
            Su plataforma para gestionar de manera eficiente los procesos de los
            programa de formación SENA.
          </p>

          <h5 className="text-primary">
            ¡Explora, aprende y crece con nosotros!
          </h5>
        </div>

        {/* MENÚ FRONTAL */}
        <MenuFrontal />


        {/* GRÁFICAS 
        <div className="mt-4">
          <Graficas />
        </div>*/}
      </div>
    </div>
  );
};

export default Home;